import React from 'react'
import { Link } from 'react-router-dom';
import heroImage from "../../images/header_background.jpg";
import "./hero.css";
const Hero = () => {
  return (
    <div className='hero'>
        <div className="mask">
            <img className='hero-image' src={heroImage} alt="" />
        </div>
        <div className="hero-text">
            <p>I'M A FREELANCER</p>
            <h1>React Developer</h1>
        
            <div className="hero-btn">
                <Link to="/projects" className='project-btn'>Projects</Link>
                <Link to="/contact" className='btn-light'>Contact</Link>
            </div>
        </div>
    </div>
  )
}

export default Hero;